import { useTranslation } from 'react-i18next';
import { API_POST, DBRequest, useConfig } from '../../api/api';
import ExoForm from '../../components/exo/ExoForm';

export const NewSalesObjectPreset = ({ salesObjectId, onClose }) => {
  const config = useConfig();
  const { t } = useTranslation();

  function handleSaveAsPreset(data) {
    const reqData = { ...data, salesObjectId };
    DBRequest({
      config,
      path: `sales-object-presets`,
      method: API_POST(reqData),
      onResponse: onClose,
    });
  }

  const fields = [
    {
      label: t('Icon'),
      type: 'icon',
      key: 'icon',
    },
    {
      label: t('Title'),
      type: 'text',
      key: 'title',
    },
  ];

  return (
    <ExoForm
      header={t('Save as preset')}
      fields={fields}
      onSubmit={handleSaveAsPreset}
    />
  );
};
